import { Injectable, inject, signal } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  activeTab = signal<number>(0);
  censusPreview = signal<boolean>(false);
  censusForm = signal<any>({});
  currentLanguage = signal<string>('it');
  isFullScreenMenuOpen = signal<boolean>(false);
  messageService = inject(MessageService);
  loader = signal<boolean>(false);

  constructor() { }

  onToastOpen(type: 'success' | 'info' | 'warn' | 'error', summary: string, message: string) {
    this.messageService.add({ severity: type, summary: summary, detail: message });
  }

}
